<template>
  <div id="excel-import-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />
    
    <div class="modal-body" v-else key="content-loading">
      
      <div v-if="!success" class="import-wrapper">
        <div v-if="validationErrors.length == 0 && type == 1">
          <label>{{ $t("components.excelImportAndExport.registrationForm") }}</label>
          <el-select v-model="payload.itemId" :placeholder="$t('components.excelImportAndExport.placeholderSelect')" class="mb-2">
            <el-option v-for="item in $store.state.registerform.registerFormList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </div>
        <div v-if="validationErrors.length == 0 && type == 3">
          <label>{{ $t("event.filter.subEvents") }}</label>
          <el-select v-model="payload.itemId" :placeholder="$t('components.excelImportAndExport.placeholderSelect')" class="mb-2">
            <el-option v-for="item in $store.state.subevents.items" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </div> 
        <div class="import-area" @click="select" v-if="validationErrors.length == 0">
          <el-col :span="24" class="d-flex align-center justify-content-center">
          <lottie-player autoplay loop mode="normal" src="/static/lottie/holacon-import-lottie.json" style="width: 100px"> </lottie-player>
        </el-col>
          <template v-if="$i18n.locale == 'tr'">
            <p>
              İçeri aktarmak istediğiniz listeyi ekledikten sonra
              <span>aktarımı başlat</span>
              butonuna basınız. Dosyayı buraya sürükleyin veya tıklayarak seçin. Bu işlem geri alınamaz.
            </p>
          </template>
          <template v-else>
            <p>
              After adding the list you want to import, click the
              <span>start transfer</span>
              button. Drag the file here or click to select. This action is irreversible.
            </p>
          </template>
        </div>
      </div>
      <div class="is-file mt-2" v-if="payload.file != null && validationErrors.length == 0">
        <div class="title">{{ payload.file.name }}</div>
      </div>
      <div class="success-file d-flex align-items-center justify-content-center flex-column" v-if="success">
        <el-col :span="24" class="d-flex align-center justify-content-center mb-2">
          <lottie-player autoplay loop mode="normal" src="/static/lottie/holacon-import-lottie.json" style="width: 150px"> </lottie-player>
        </el-col>
        <p class="text-info">{{ $t("components.excelImportAndExport.transferCompleted") }}</p>
      </div>
      <div class="error-list" v-if="validationErrors.length > 0">
        <h4>{{ $t("components.excelImportAndExport.errorList") }}</h4>
        <p class="text-danger" v-for="(error, errorIndex) in validationErrors" :key="errorIndex + '-error'">{{ error.value }}</p>
      </div>
      <input type="file" @change="uploadFile" style="display: none" ref="file" />
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("components.excelImportAndExport.close") }}</el-button>
      </div>
      <div v-if="!success" class="right-buttons">
        <el-button type="danger" @click="clearToAll" v-if="payload.file">{{ $t("components.excelImportAndExport.clear") }}</el-button>

        <el-button type="primary" @click="uploadToServer" :loading="loading == 'uploadServer'">{{ $t("components.excelImportAndExport.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["type"],
  name: "ExcelImport",
  data() {
    return {
      lottieShow: false,
      success: false,
      payload: {
        file: null,
        type: 1,
        itemId: null
      },
      progress: 0,
      axios,
      validationErrors: [],
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getRegisterForm");
      this.loading = false;
    }, 500);
  },
  methods: {
    select() {
      this.$refs.file.click();
    },
    clearToAll() {
      this.$refs.file.value = null;
      this.payload.file = null;
      this.payload.type = 1;
      this.payload.itemId = null;
      this.validationErrors = [];
      this.success = false;
    },
    async uploadToServer() {
      this.loading = "uploadServer";
      if (this.timeout != null) clearTimeout(this.timeout);
      var fd = new FormData();
      fd.append("file", this.payload.file);
      this.payload.type = this.type;
      this.timeout = setTimeout(async () => {
        var res = await axios.post(`statistics/importxlsx?type=${this.payload.type}&itemId=${this.payload.itemId != null ? this.payload.itemId : ""}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          if (this.type == 1) {
            await this.$store.dispatch("getParticipants");
          }
          if (this.type == 3) {
            await this.$store.dispatch("getSubEvents");
          }
          await this.$store.dispatch("getTags");
          this.$message.success(res.data.alert.message);
          this.success = true;
        }
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async uploadFile() {
      let file = this.$refs.file.files[0];
      this.payload.file = file;
      this.$refs.file.value = null;
    }
  }
};
</script>
<style lang="less">
.import-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #03658c;
  min-height: 200px;
  border-radius: 8px;
  cursor: pointer;
  & > p {
    width: 400px;
    text-align: center;
    word-wrap: break-all;
    font-weight: 500;
    color: #03658c;
    & > span {
      color: #f69656;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExcelImport.vue